import { IChangeRequestWell } from '../../interfaces/ichange-request-well';
import { ChangeRequest } from '../change-request';
import { Well } from '../well';

export class ChangeRequestWellBase {
  ChangeRequestWellId: number;
  ChangeRequestId: number;
  WellId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ChangeRequest?: ChangeRequest;
  Well?: Well;

  constructor(item?: IChangeRequestWell) {
    if (item) {

      this.ChangeRequestWellId = item.ChangeRequestWellId;
      this.ChangeRequestId = item.ChangeRequestId;
      this.WellId = item.WellId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ChangeRequest = new ChangeRequest(item.ChangeRequest);
      this.Well = new Well(item.Well);
    }
  }
}